// components/HelpBody.js
import React from "react";
import {
  Box,
  Typography,
  TextField,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Button,
} from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import BusinessIcon from "@mui/icons-material/Business";
import SearchIcon from "@mui/icons-material/Search";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import KeyIcon from "@mui/icons-material/VpnKey";
import LockIcon from "@mui/icons-material/Lock";
import StorefrontIcon from "@mui/icons-material/Storefront";
import GroupIcon from "@mui/icons-material/Group";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { useNavigate } from "react-router-dom";

const cards = [
  {
    icon: <AccountBoxIcon />,
    title: "Account settings",
    desc: "Adjust settings, manage notifications, learn about name changes and more.",
    path: "/helpcenterlayout/account-settings",
  },
  {
    icon: <KeyIcon />,
    title: "Login and password",
    desc: "Fix login issues and learn how to change or reset your password.",
    path: "/helpcenterlayout/login-password",
  },
  // {
  //   icon: <LockIcon />,
  //   title: "Privacy and security",
  //   desc: "Control who can see what you share and add extra protection to your account.",
  //   path: "/privacy-security",
  // },
  // {
  //   icon: <StorefrontIcon />,
  //   title: "Marketplace",
  //   desc: "Learn how to buy and sell things on Facebook.",
  //   path: "/marketplace",
  // },
  // {
  //   icon: <GroupIcon />,
  //   title: "Groups",
  //   desc: "Learn how to create, manage and use Groups.",
  //   path: "/groups",
  // },
  {
    icon: <InsertDriveFileIcon />,
    title: "Pages",
    desc: "Learn how to create, use, follow and manage a Page.",
    path: "/helpcenterlayout/pages",
  },
];

const gradients = [
  "linear-gradient(45deg, #FF9A8B, #FF6A88)",
  "linear-gradient(45deg, #a18cd1, #fbc2eb)",
  "linear-gradient(45deg, #f093fb, #f5576c)",
  "linear-gradient(45deg, #43e97b, #38f9d7)",
  "linear-gradient(45deg, #30cfd0, #330867)",
  "linear-gradient(45deg, #667eea, #764ba2)",
];

const HelpcenterDashboard = () => {
  const navigate = useNavigate();

  return (
    <Box flex={1} px={4} py={6}>
      <Box maxWidth="900px" mx="auto">
        <Typography variant="h5" fontWeight="bold" textAlign="left">
          How can we help you?
        </Typography>

        <Box mt={2}>
          <TextField
            fullWidth
            placeholder="Search help articles..."
            variant="outlined"
            InputProps={{
              startAdornment: <SearchIcon sx={{ color: "gray", mr: 1 }} />,
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
                height: 48,
                paddingLeft: 1,
              },
            }}
          />
        </Box>

        <Box mt={3}>
          <Typography variant="h6" textAlign="left" fontWeight={500}>
            Popular topics
          </Typography>
          <Card sx={{ backgroundColor: "#e7f3ff", mt: 2, p: 2 }}>
            <Box display="flex" alignItems="center">
              <HelpIcon color="primary" sx={{ fontSize: 40, mr: 2 }} />
              <Box flexGrow={1}>
                <Typography variant="body1" fontWeight="bold">
                  Need help with logging in?
                </Typography>
                <Typography variant="body2">
                  Learn what to do if you're having trouble with getting back on
                  Facebook.
                </Typography>
              </Box>
              <Button variant="contained">Get Help</Button>
            </Box>
          </Card>

          <Grid container spacing={5} mt={6}>
            {cards.map((item, index) => (
              <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                <Card
                  sx={{ height: 220, display: "flex", flexDirection: "column" }}
                >
                  <CardActionArea
                    sx={{ height: "100%" }}
                    onClick={() => navigate(item.path)}
                  >
                    <CardContent
                      sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        textAlign: "center",
                      }}
                    >
                      <Box display="flex" justifyContent="center">
                        <Box
                          sx={{
                            background: gradients[index % gradients.length],
                            width: 60,
                            height: 60,
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            mb: 1,
                          }}
                        >
                          {React.cloneElement(item.icon, {
                            sx: { color: "#fff", fontSize: 30 },
                          })}
                        </Box>
                      </Box>

                      <Typography fontWeight="bold" gutterBottom>
                        {item.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                        }}
                      >
                        {item.desc}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default HelpcenterDashboard;
